const movies = [
  {
    id: 1,
    title: "바람의 향기",
    lng: "Scent of Wind",
    genre: "가족/아동 · 여행/로드무비 · 인권/노동/사회",
    director: "하디 모하게흐",
    note: "세상이 너무 삭막하고, 인간이 너무 무섭다고 느껴질 때가 있다. 매일 접하는 뉴스의 많은 부분이 그렇다. 인간의 선의가 아직 남아 있는지 의심스러운 세태 속에서 <바람의 향기>는 사람에 대한 믿음을 확인시켜 주는 영화다. 이란의 외딴 시골 마을, 하반신 장애가 있는 남자가 전신 마비 상태의 아들을 간호하며 살고 있다. 어느 날, 전기가 끊겨 전력 담당자가 이곳을 찾는다. 고장 난 부품을 교체하기 위해 백방으로 알아보며 이 마을 저 마을 다닌다. 압바스 키아로스타미의 영화적 전통을 이어받은 <바람의 향기>는 느리고 조용하지만 진한 여운을 남기는 영화다. 등장인물들은 장애를 지닌 사람들이거나, 장애물에 걸려 어찌할 바를 모르는 사람들이다. 그럴 때마다 그들은 서로를 외면하지 않고 작은 도움의 손길을 내민다. 심지어 하반신 장애를 지닌 남자는 가던 길을 멈추고 돌아와 바늘귀에 실을 꿰지 못해 애먹는 노인을 돕는다. 누군가를 돕는 장면만으로 영화는 잊을 수 없는 풍경들을 만들어낸다. 연인을 만나러 가는 시각 장애인을 위해 만들어 준 꽃다발이, 마침내 그들의 만남을 통해 전달되는 장면은 이 영화가 시가 되는 순간이다. <아야즈의 통곡>으로 2015년 부산국제영화제 뉴커런츠상을 수상한 하디 모하게흐 감독의 네 번째 영화로 감독이 직접 주연을 맡았다. 숱한 영화가 세상의 비참에 주목하는 동안 그 비참을 이겨내는 인간의 따뜻한 마음을 전하는, 귀한 작품이다. (남동철)",
    tit: "개막작",
    nation: "Iran",
    year: "2022",
    time: "90min",
    format: "DCP",
  },
  {
    id: 2,
    title: "밤, 혹은 클라라의 죽음",
    lng: "The Night of the 12th",
    genre: "심리/미스터리/서스펜스/스릴러 · 여성",
    director: "도미닉 몰",
    note: "2016년 10월 12일 밤, 21세의 클라라 로이에가 온몸에 휘발유를 덮어쓰고 산채로 불태워졌다. 누가 이런 야만적인 짓을 저질렀나? 요한과 사법경찰은 클라라 측근을 중심으로 탐문에 나선다. 클라라가 사귀던 남자들 중 한 명이 저지른 보복 행위라는 데에는 의심의 여지가 없다. 수사에는 진척이 없는데 경찰은 설상가상으로 피해자의 개방적인 성격과 자유로운 연애관을 섣불리 판단하려 든다. 스릴러의 거장 도미닉 몰은 단순한 살인 사건을 넘어, 여성에 대한 폭력 전반을 주제로 치밀한 수사를 펼친다. 얼굴 없는 살인자는 누구인가? 여성의 몸을 자기 것으로 생각하는 남성, 또한 본인의 힘을 증명하기 위해 한 여자를 죽일 준비가 되어있는 사람들... 실화를 바탕으로 인간 영혼의 가장 어두운 면을 파헤치는 스릴러 <밤, 혹은 클라라의 죽음>은 많은 프랑스 비평가와 관객이 봉준호의 <살인의 추억>(2003)과 비교했던 작품이기도 하다. (서승희)",
    tit: "와이드 앵글",
    nation: "France",
    year: "2022",
    time: "114min",
    format: "DCP",
  },
  {
    id: 3,
    title: "에브리씽 에브리웨어 올 앳 원스",
    lng: "Everything Everywhere All at Once",
    genre: "SF/판타지 · 코미디/유머/블랙코미디/풍자 · 액션/무협",
    director: "Dan KWAN 댄 콴, Daniel SCHEINERT 다니엘 쉐이너트",
    note: "중국계 중년여성 에벌린의 인생은 복잡다단하다. 운영하는 빨래방은 국세청의 까다로운 감사를 받고, 남편은 그녀 몰래 이혼 서류를 준비한다. 하나뿐인 딸은 커밍아웃 후 동성애자 애인을 보수적인 할아버지에게 소개하겠다며 고집을 피운다. 어느 날, 에벌린은 국세청 사무실에서 감사를 받다 자신의 전생들이 연결 된 ‘멀티버스’ 세계에 빠진다. 어리둥절한 에벌린은 무엇이 현실인지도 모른 채 딸의 형체를 한 악의 신 ‘조부투파키’로 부터 세상을 구해야 하는 처지가 되는데... 올해 미국에서 개봉된 영화 중 단연 최고 화제작으로 꼽히는 <에브리씽 에브리웨어 올 앳 원스>는 sci-fi, 코미디, 드라마, 화려한 무술 액션까지 오락영화가 가질 수 있는 모든 장르를 총망라한 작품이다. 주인공역으로 수 많은 장르를 소화하는 양자경의 매력에 푹 빠질 수밖에 없는 이 작품은, 올해SXSW에서 처음 소개되면서부터 특히 젊은 층으로부터 폭발적인 반응을 얻었다.",
    tit: "뉴 커런츠",
    nation: "United States",
    year: "2022",
    time: "140min",
    format: "DCP",
  },
  {
    id: 4,
    title: "알카라스의 여름",
    lng: "Alcarràs",
    genre: "가족/아동 · 인권/노동/사회",
    director: "카를라 시몬",
    note: "<프리다의 그해 여름>(2018)으로 베를린영화제의 장편데뷔상을 받았던 카를라 시몬에게 올해 황금곰상의 영예를 안겨준 작품이다. 3대가 함께 운영해온 복숭아 농장에 지주의 통보가 도착한다. 대가족은 여름을 끝으로 삶의 터전에서 떠나야 한다. 경제적 토대의 몰락과 미래의 불안은 평화롭던 카탈루냐의 알카라스 지역에 바람을 몰고 온다. 가족의 관계에 서서히 균열이 일어나고, 농업이 기반인 지역공동체는 위기를 맞는다. 그 와중에, 엇나가는 아이들을 보면서 어떻게든 마지막 수확을 완수하려는 아버지의 노력이 눈물겹다. 정의의 문화인 저항의 전통 아래 만들어진 작품이지만, 영화의 목소리는 나지막하다. 이것은 비단 알카라스의 문제만은 아니기에, 베를린영화제의 지지는 옳다. 지지에 동참하는 길은 멀리 있지 않다. 마음속에 소중한 불씨 하나를 피우는 것. (이용철)",
    tit: "와이드 앵글",
    nation: "Spain/Italy",
    year: "2022",
    time: "121min",
    format: "DCP",
  },
  {
    id: 5,
    title: "헤어질 결심",
    lng: "Decision to Leave",
    genre: "사랑/연애/로맨스 · 심리/미스터리/서스펜스/스릴러",
    director: "박찬욱",
    note: "박찬욱 감독의 11번째 장편영화 <헤어질 결심>은 형사 해준(박해일)과 남편을 타살한 혐의를 받는 용의자 서래(탕웨이)의 만남과 헤어짐을 따라간다. 불면증에 시달리는 형사는 매일 밤 용의자를 감시하며 자신도 모르게 서서히 물들어간다. 형사와 용의자의 관계를 사랑에 빠진 연인의 긴장감으로 예민하게 치환시킨 이 영화는 박찬욱 감독의 필모그래피에서도 유독 솔직하고 정서적이다. 박찬욱 감독 특유의 탐미적인 미장센, 과감하면서도 유려한 편집, 문학적인 대사와 꼼꼼한 상징들은 그야말로 탁월하다. 특히 수사극과 느와르의 형식 위로 포개어지는 감정의 얼룩들은 쉽사리 지워지지 않는다. ‘사랑’이라는 단어 한 번 입 밖에 꺼내지 않고 그 형상을 더듬어 포착한, 극한의 세공이 돋보이는 영화다. (송경원)",
    tit: "아시아영화의 창",
    nation: "Korea",
    year: "2022",
    time: "138min",
    format: "DCP",
  },
  {
    id: 6,
    title: "내가 꿈꾸는 나라",
    lng: "My Imaginary Country",
    genre: "정치 · 역사/전쟁",
    director: "고레에다 히로카즈",
    note: "영화는 살바도르 아옌데를 향한 민중의 환호로 시작한다. 하지만 쿠데타는 삶과 변화의 꿈을 산산이 깨버렸다. 2019년 10월, 칠레가 다시 폭발했다. <칠레 전투>(1975, 1976, 1979)에서 그랬듯, 사회의 변혁을 기록하는 구즈만의 카메라는 ‘두 번째 혁명이 가능한지, 자본주의로 치닫던 국가의 영혼이 어떻게 깨어났는지’ 질문한다. 그는 전혀 다른 세대를 명확하게 인지한다. 그들에겐 정파적 지도자가 없으며, 특정 이데올로기의 지배 없이 공동의 꿈을 향해 한 몸으로 저항한다. 그리고 새로운 혁명의 중심에는 여성의 목소리가 있음을 아는 구즈만은 오로지 여성을 대상으로 인터뷰한다. 구즈만은 체제의 변화라는 희망을 앞두고 다시는 <칠레 전투>(1975, 1976, 1979)의 시간이 반복되는 일이 벌어지지 않기를 바란다. 그러므로 이건 노대가의 간절한 기도에 다름 아니다. (이용철)",
    tit: "뉴 커런츠",
    nation: "France/Chile",
    year: "2022",
    time: "83min",
    format: "DCP",
  },
  {
    id: 7,
    title: "브로커",
    lng: "Broker",
    genre: "",
    director: "고레에다 히로카즈",
    note: "고레에다 히로카즈의 가족 이야기는 전환과 확장의 길을 걸어왔다. <브로커>에서 그는 대안 가족의 가능성을 탐색한다. 미혼모 소영(이지은)은 자신의 아이 우성을 베이비박스에 두고 가고, 상현(송강호)과 동수(강동원)는 우성을 데려다 아기를 원하는 이에게 팔려고 하는데, 다음 날 소영이 우성을 다시 찾으러 오면서 혼란에 빠진다. 하지만 소영 또한 우성에게 좋은 부모를 찾아 주기로 결심하면서 그들은 함께 여정에 오른다. 이 상황을 모두 지켜보던 형사 수진(배두나)이 그들을 바짝 뒤쫓는다. <브로커>는 소영과 우성, 상현과 동수가 대안 가족을 이루는 과정을 온정 어린 시선으로 바라본다. (홍은미)",
    tit: "뉴 커런츠",
    nation: "Korea",
    year: "2022",
    time: "130min",
    format: "DCP",
  },
  {
    id: 8,
    title: "고속도로 가족",
    lng: "Highway Family",
    genre: "가족/아동",
    director: "이상문",
    note: "기우(정일우)는 만삭의 아내와 어린 아들, 딸과 함께 고속도로 휴게소를 전전하며 노숙한다. 한편 영선(라미란)은 기우네 가족을 불쌍히 여기게 된다. <고속도로 가족>은 경제적으로 무너졌지만 화목해 보이는 기우네 가족과 지울 수 없는 상처를 지닌 영선네 가족 사이에 인연의 다리를 놓는다. <고속도로 가족>에는 온기 있게 인물들을 바라보는 사려 깊은 시선이 돋보인다. 이상문 감독은 노숙자 가족이라는 흥미로운 설정을 단순히 극적인 소재로 활용하지 않기 위해 여러 장치를 마련한다. 카메라는 각 가족을 대표하는 기우와 영선은 물론 가족 구성원 한 명 한 명의 사연을 충분한 시간을 들여 가만히 듣는다. 라미란, 정일우, 김슬기, 백현진 등 배우들의 설득력 있는 연기와 차분한 전개가 극의 안정감을 높인다. (송경원)",
    tit: "한국영화의 오늘",
    nation: "Korea",
    year: "2022",
    time: "129min",
    format: "DCP",
  },
  {
    id: 9,
    title: "소년들",
    lng: "The Boys",
    genre: "스페셜 프리미어",
    director: "정지영",
    note: "1999년 시골 소읍의 한 슈퍼마켓에 강도 치사 사건이 벌어진다. 경찰은 세 명의 소년들을 진범으로 지목, 빠르게 수사를 종결한다. 얼마 뒤 새로 부임한 황준철(설경구) 반장은 경찰 고위직 최우성(유준상)과 무리들이 성과를 앞세워 이 사건을 조작했다는 확신을 갖게 된다. 그는 특유의 끈질기고 강직한 수사력으로 재수사와 재심을 시도한다. 실화를 기반으로 한 <소년들>은 실화와 허구 사이에서 흥미로운 영화를 만들어 내기로 유명한 정지영 감독의 신작이다. 영화는 과거와 현재를 오가며 장르적 재미를 높이는 동시에 약자들의 마음을 따뜻하게 어루만지는 소영웅 서사를 펼쳐낸다. 설경구, 유준상, 진경, 허성태, 염혜란 등 호화 캐스팅도 돋보인다. (정한석)",
    tit: "한국영화의 오늘",
    nation: "Korea",
    year: "2022",
    time: "124min",
    format: "DCP",
  },
  {
    id: 10,
    title: "20세기 소녀",
    lng: "20th Century Girl",
    genre: "사랑/연애/로맨스 · 성장영화/청춘",
    director: "방우리",
    note: "보라(김유정)의 둘도 없는 친구 연두(노윤서)는 심장 수술을 위해 미국에 가면서 자신이 좋아하는 남자 백현진(박정우)에 대한 모든 정보를 수집해 달라고 보라에게 부탁한다. 보라는 백현진의 가장 친한 친구 풍운호(변우석)와 먼저 친해지기로 한다. 하지만 보라의 서투른 계획은 예상치 못한 방향으로 전개된다. 새로운 세기가 오기 1년 전인 1999년, 17세가 된 보라는 첫사랑의 열병에 빠진다. 방우리 감독의 <20세기 소녀>는 1999년 어느 소녀 소년들의 싱그러운 사랑과 그 이후에 관한 영화다. 김유정을 비롯하여, 신인 변우석, 박정우, 노윤서가 연기하는 인물들은 모두가 하나 같이 사랑스럽고 귀엽다. <20세기 소녀>에는 시종일관 밝고 유쾌한 온기가 담겨 있다. 20세기의 청춘에게는 향수를, 21세기의 청춘에게는 설렘을 안긴다. (정한석)",
    tit: "한국영화의 오늘",
    nation: "Korea",
    year: "2022",
    time: "119min",
    format: "DCP",
  },

  {
    id: 11,
    title: "남쪽, 적막철도",
    lng: "20th Century Girl",
    genre: "도시/도시화 · 실화바탕",
    director: "샤오추첸",
    note: "기차 덕후라면 <남쪽, 적막철도>를 놓칠 수 없다. 총 길이 98.2킬로미터로 1992년 개통해, 대만 남부를 횡단하는 철도의 탄생부터 마지막 시기까지를 한편의 영화로 담았다. 이 철도와 관계한 구체적인 사람들을 직접 만나 그들의 입으로 기차의 역사를 다시 쓰는 데에 이 영화의 미덕이 있다. 기차 노선 설계자, 터널을 뚫고 철로를 낸 건설 노동자, 기관사와 승무원을 비롯한 철도 노동자들의 생생한 육성을 성실히 수집한다. 철도가 생기면서 달라진 주변 풍광을 증언하는 이들, 철로 주변에서 생계를 이어온 사람들, 기차 사진 전문가, 기차 연구자, 기차 부품 수집광의 이야기도 빼놓지 않는다. 남방 철도에 관한 전 방위적인 구술 아카이브로서 충분히 의미 있는 자료이자 기차로 본 대만의 자화상으로도 손색없다. (정지혜)",
    tit: "와이드 앵글",
    nation: "Taiwan",
    year: "2022",
    time: "113min",
    format: "DCP",
  },
  {
    id: 12,
    title: "따스한 오후",
    lng: "Southern Afternoon",
    genre: "가족/아동",
    director: "란 티안",
    note: "중국어를 읽지 못하는 소수민족 아빠는 큰딸이 연애편지를 받은 게 아닐까 의심한다. 어쩔 수 없이 작은딸에게 편지 내용을 읽어보라고 한다.",
    tit: "와이드 앵글",
    nation: "China",
    year: "2022",
    time: "15min",
    format: "DCP",
  },
  {
    id: 13,
    title: "글리치",
    lng: "Glitch",
    genre: "모험 · SF/판타지 · 여성 ",
    director: "노덕",
    note: "홍지효(전여빈)의 주변에는 오래전부터 외계인이 어슬렁거려 왔다. 애인(이동휘)이 실종되는 사건이 벌어지자 홍지효는 미스터리 동호회를 찾아 사건의 실마리를 찾으려 하고, 거기에서 중학교 동창 허보라(나나)를 만난다. 둘은 이제 기막힌 모험을 시작한다. <글리치>는 빛나는 조합의 결과물이다. 화제의 시리즈물 <인간수업>(2020)의 진한새 작가와 스튜디오 329 제작사가 다시 뭉쳤고, 신선한 장르 감각을 지닌 노덕 감독이 가세했다. 전여빈과 나나가 연기해내는 캐릭터들은 엉뚱하면서도 귀엽다. 흥미로운 서사 전개뿐만 아니라 창의적인 시각적 아이디어들도 돋보인다. <글리치>는 모험물이자, SF물이고, 미스터리 물이면서, 코미디이기도 한, 장르적 매력 덩어리다. 10부작 중 4부를 상영한다. (정한석)",
    tit: "뉴 커런츠",
    nation: "Korea",
    year: "2022",
    time: "189min",
    format: "DCP",
  },
  {
    id: 14,
    title: "경관의 피",
    lng: "The Policeman′s Lineage",
    genre: "범죄/폭력 · 심리/미스터리/서스펜스/스릴러",
    director: "이규만",
    note: "<경관의 피>는 범인 검거에 수단을 가리지 않는 부도덕한 경찰과 이를 감시하는 신입 경찰의 고뇌를 따라간다. 3대째 경찰이 된 민재(최우식)는 원리원칙을 중시한다. 상부에서는 민재에게 광역수사대 반장 강윤(조진웅)의 내사를 지시한다. 서슴없이 위법수사를 저지르는 강윤을 보며 민재는 환멸과 의심, 존경과 질투를 동시에 느낀다. <경관의 피>는 양파껍질처럼 여러 겹의 메시지를 둘러싼 영화다. 표면적으로는 혼란스러운 신입과 정체를 알 수 없는 베테랑의 버디무비처럼 보이지만 중심에는 민재의 성장담이 자리한다. 3대에 걸친 ‘경찰의 피’는 신입 민재의 긍지이자 족쇄다. 미숙해서 사랑스런 존재가 도덕적 딜레마 한가운데에서 어떤 답을 내놓을지 따라가는 과정을 진지하게 그려 나간다. (송경원)",
    tit: "한국영화의 오늘",
    nation: "Korea",
    year: "2022",
    time: "120min",
    format: "DCP",
  },
  {
    id: 15,
    title: "더더더",
    lng: "Jooyoung in Wonderland",
    genre: "도시/도시화 · 코미디/유머/블랙코미디/풍자",
    director: "정해일",
    note: "연말 분위기로 들썩이는 퇴근길에 주영은 팀장의 전화를 받고 차를 돌린다. 회사로 돌아가 야근을 해야 하는 상황도 짜증 나는데, 우연찮은 해프닝으로 음주운전 단속에 걸려 도로에 발이 묶인다. 환장의 점입가경, 한밤의 난장이다. 개성 강한 캐릭터들이 빚어내는 상황 소동극.",
    tit: "와이드 앵글",
    nation: "Korea",
    year: "2022",
    time: "29min",
    format: "DCP",
  },
  {
    id: 16,
    title: "호수",
    lng: "Lake and I",
    genre: "성장영화/청춘 · 여성",
    director: "박소현",
    note: "정현은 친구 호수의 전화를 받고 호수네 대중목욕탕 청소를 돕고 욕조에 함께 몸을 담근다. 소소한 대화, 막연한 걱정, 막막한 미래. 두 친구의 하루가 물 흐르듯 흘러간다. 물을 모티프로 선명한 드라마 없이 자기의 톤과 무드를 만들어가는 재능이 예사롭지 않다.",
    tit: "와이드 앵글",
    nation: "Korea",
    year: "2022",
    time: "13min",
    format: "DCP",
  },
  {
    id: 17,
    title: "부서지는 파도",
    lng: "When the Waves are Gone",
    genre:
      "범죄/폭력 · 심리/미스터리/서스펜스/스릴러 · 분노/복수 · 인권/노동/사회 ",
    director: "라브 디아즈",
    note: "미제사건을 해결하는 유능한 경관인 에르메스는 마약과의 전쟁이 시작되자 직업에서의 모순을 느끼게 된다. 하루에도 여러번 길거리에서 처단된 소위 “마약 범죄자”의 시신을 목도하며 스트레스성 피부염에 시달린다. 게다가 자주 집을 비운 사이 바람을 피게 된 아내와 자신의 동료 경찰을 폭행하기에 이른다. 또다른 남자 프리모는 복역중 뒷배를 봐주는 윗선에 의해 조기출소한다. 조울증과 분노조절장애를 겪는 그는 자신만의 방식으로 과거를 청산하고자 하지만, 가장 자유를 만끽하는 순간에도 통제불능에 빠진다. 절제된 흑백화면과 롱테이크는 은밀하고도 개인적인 시간과 대화를 타임캡슐에 담듯 녹여내며 두 남자의 관계를 드러낸다. 그리고 온갖 아이러니와 모순을 내재한 현대사회에서 정의가 폭력으로 구현될 수 있는가를 질문하고 있다. (박성호)",
    tit: "뉴 커런츠",
    nation: "Philippines/France/Portugal/Denmark",
    year: "2022",
    time: "188min",
    format: "DCP",
  },
  {
    id: 18,
    title: "토라의 남편",
    lng: "Tora′s Husband",
    genre: "가족/아동 · 도시/도시화 · 인권/노동/사회",
    director: "리마 다스",
    note: "팬데믹으로 오랜 폐쇄(lockdown)를 견뎌낸 도시는 여전히 구급차와 통곡으로 소란하고, 생활고와 불안으로 사람들의 일상은 위태롭다. 식당과 베이커리를 경영하며 토목사업을 하는 잔은 인력과 자금 조달에 어려움을 겪고 있고, 종업원들은 매일 말썽을 일으킨다. 그는 어려운 와중에도 직원들의 고용을 유지하고 자선을 베푸는 선량한 사장님이며, 책임감 있는 아들, 자상한 아버지, 막역한 친구이자 강아지에게도 충실한 반려인이지만, 그 모든 정체성을 뒤로 하고 영화는 ‘토라의 남편’ 자리에 이 남자를 최종 소환한다. 코비드 팬데믹이 우리에게서 무엇을 빼앗아 갔고 무엇을 가져다주었는지, 익숙하면서도 낯설게 들여다보게 하는 작품으로, <노래하는 불불>(2018)과 <빌리지 록스타>(2017)로 주목받은 리마 다스가 연출했다. (최은)",
    tit: "아시아영화의 창",
    nation: "India",
    year: "2022",
    time: "140min",
    format: "DCP",
  },
  {
    id: 19,
    title: "세일즈 걸",
    lng: "The Sales Girl",
    genre: "성장영화/청춘 · 여성 · 코미디/유머/블랙코미디/풍자",
    director: "센게도르지 잔치브도르지",
    note: "사룰은 조용한 성격으로 그림 그리는 것을 좋아하지만 부모님의 권유로 적성에도 맞지 않는 원자력공학과를 다니고 있다. 어느 날 바나나에 미끄러져서 넘어지는 바람에 하던 일을 못 하게 된 친구가 대신 아르바이트를 해달라고 부탁한다. 그곳은 다름 아닌 섹스숍. 사룰과는 전혀 어울릴 것 같지 않은 곳이지만 친구는 자신의 비밀을 가장 잘 지켜줄 것 같은 사룰을 설득한다. 온갖 모양과 종류의 성인용품을 판매하고 가끔 배달을 하며 영업 종료 후에는 가게 주인 카티야에게 정산금과 고양이사료를 가지고 찾아가는 것이 일이다. 사룰은 시간이 지날수록 스스로 겪어보지 못하고 알지 못하는 많은 것들을 아는 듯한 카티야에게 흥미를 느낀다. 그리고 두 사람의 특별한 우정은 서로의 삶에 변화를 일으킨다. 예상치 못한 곳에 등장하는 귀여운 연출과 음악이 돋보인다. (박성호)",
    tit: "아시아영화의 창",
    nation: "Mongolia",
    year: "2021",
    time: "124min",
    format: "DCP",
  },
  {
    id: 20,
    title: "약한영웅 Class 1",
    lng: "Weak Hero Class 1",
    genre: "범죄/폭력 · 성장영화/청춘 · 액션/무협 ",
    director: "YOU Su-min 유수민",
    note: "<약한영웅 Class 1>은 진짜 강함이 무엇인지 되묻는 액션 성장 드라마다. 연시은(박지훈)은 공부 외엔 관심이 없지만 걸어온 싸움을 피하지도 않는다. 타고난 두뇌로 유리한 상황을 만들고 주변 도구를 활용하여 자신을 보호하던 시은이지만 혼자이기에 결국 위기가 닥치고, 그 순간 또 다른 아웃사이더 안수호(최현욱)와 전학생 오범석(홍경)의 도움을 받는다. 그렇게 정글 같은 학교에서 살아남기 위해 따로 또 같이 싸우던 이들 사이에 묘한 우정이 싹튼다. 동명의 웹툰을 원작으로 한 <약한영웅 Class 1>은 장르적 재능이 넘치는 신예 유수민 감독과 <D.P.>로 잘 알려져 있는 한준희 크리에이티브 디렉터가 합을 맞췄다. 각기 다른 캐릭터들의 매력이 고루 돋보이는 가운데 타인과 관계하는 법을 배우며 성장하는 인물들의 모습을 흥미롭게 그려 나간다. 8부작 중 3부를 상영한다. (송경원)",
    tit: "뉴 커런츠",
    nation: "Korea",
    year: "2022",
    time: "123min",
    format: "DCP",
  },
  {
    id: 21,
    title: "한 남자",
    lng: "A Man",
    genre:
      "리메이크/원작있음 · 범죄/폭력 · 사랑/연애/로맨스 · 심리/미스터리/서스펜스/스릴러 · 인권/노동/사회",
    director: "이시카와 케이",
    note: "2018년 요미우리문학상을 받은 히라노 게이치로의 동명 소설을 영화로 옮겼다. 츠마부키 사토시, 안도 사쿠라, 구보타 마사타카 등이 출연하며 <우행록: 어리석은 자의 기록>(2016)으로 주목받은 이시카와 케이 감독이 연출했다. 이혼하고 아이와 함께 고향에 내려와 살던 리에(안도 사쿠라)는 다이스케(구보타 마사타카)라는 남자를 만나 사랑을 빠진다. 성실하고 착한 남편과 아이도 낳고 행복한 생활을 하던 어느 날, 다이스케가 사고로 세상을 떠난다. 장례를 치르는 중에 다이스케의 형이라는 사람이 찾아와 죽은 남편의 사진을 보며 이 사람은 내 동생 다이스케가 아니라고 말한다. 남편이 다이스케가 아니라면 누구인가? 리에는 변호사 키도(츠마부키 사토시)에게 남편이 누구였는지 알아봐달라고 부탁한다. 내가 알던 사람이 한 순간 정체를 알 수 없는 사람으로 바뀔 때 우리의 이성과 감정은 어떤 반응을 보이는가? 사람의 정체성에 대해 묻는 <한 남자>는 키도를 재일교포로 설정하면서 질문의 수위를 정치적인 문제로 확장한다. 아내의 가족은 아직도 남편인 키도가 한국인의 피를 갖고 있다는 사실에 거부감을 드러낸다. 키도는 사실에 접근해가면서 자신의 정체성에 대한 물음과도 대면한다. 자신의 과거를 지우고 싶은 욕망과 나를 나로 만드는 정체성에 대한 진지한 질문을 미스터리 속에 충실히 담아냈다. (남동철)",
    tit: "폐막작",
    nation: "Japan",
    year: "2022",
    time: "123min",
    format: "DCP",
  },
];

const DB = [
  {
    id: 1,
    title: "제 27회, 2022",
    des: "제 27회 부산국제영화제 포스터는 맑은 하늘 아래 바다를 응시하는 인물의 모습이 담겨 있다. ‘영화의 바다’라 불리는 부산국제영화제와 인물이 서로 마주하는 모습을 통해 팬데믹 이후 3년 만의 정상화 개최에 대한 설렘을 고스란히 담았다. 포스터 속 인물의 존재는 관객을 포함해 영화제를 방문하는 게스트, 산업 관계자 등 모든 영화인을 상징하는 만큼 특별한 의미를 더한다.\n \n올해 공식포스터는 부산국제영화제 미술감독으로 활동하고 있는 최순대 부산 현대시각디자인협회장이 지난해에 이어 2년 연속으로 포스터 제작을 맡았다.",
  },
  {
    id: 2,
    title: "제 26회, 2021",
    des: "제26회 부산국제영화제 공식 포스터는 한국 전통 모시천의 실사를 바탕으로 부산국제영화제의 영문 표기를 손글씨로 흘려 쓴 디자인 작품이다. 부산국제영화제의 주색인 붉은 색 계열 모시천을 실사 촬영해 다양한 색으로 변주했다.\n다채로운 색의 모시천을 겹쳐 색을 변주한 이번 포스터 배경은 세계 영화를 선보이는 ‘축제의 장’이 된 ‘영화의 도시’ 부산을 나타낸다.\n\n \n포스터 하단의 짙은 보라와 자주색은 부산의 밤바다를, 포스터 중앙에 여러 색깔의 모시천이 겹쳐지는 부분은 영화제가 펼쳐지는 하늘과 그 아래 공간을 의미한다. 화면 중앙을 둘러싸는 형태로 배치된 7가지 색상의 정사각형은 각기 다른 문화권에서 제작된 각국의 다양한 영화를 상징한다.",
  },
  {
    id: 3,
    title: "제 25회, 2020",
    des: "제25회 부산국제영화제가 공식 포스터를 공개했다.\n제25회 부산국제영화제 공식 포스터는 시대적 어려움에 꺾이지 않고 새로운 시간의 축을 세워나가는 시대 정신을 담아냈다. 망망대해 위 우뚝 서 있는 조형물은 영화의 바다를 지키는 부산국제영화제의 존재를, 어둠을 뚫고 나온 빛은 어떤 난관에도 꺼지지 않는 영사기 빛을 형상화했다. 포스터를 휘감고 있는 푸른 빛은 아침의 시작을 알리고, 어둠에 지지 않고 내일을 깨우는 우리 모두를 상징한다.\n \n김상만 감독이 만든 포스터는 한국 영화계에 몸담고 있는 영화인이 만든 최초의 포스터로 더욱 뜻 깊다. 김상만 감독은 영화연출, 영화 미술감독, 포스터 디자이너 등 영화 산업에서 다방면으로 활약하고 있다.",
  },
  {
    id: 4,
    title: "제 24회, 2019",
    des: "공개된 공식포스터는 그동안 부산국제영화제 현장을 찾았던 사람들이라면 한 번은 봄직한 친근한 이미지를 바탕으로 하고 있다. 총천연색의 깃발이 떠오르는 이번 포스터는 아시아 각국 국기들의 색조들과 동시에 개막식이 거행되는 부산 영화의전당 LED 지붕인 ‘빅루프’와 ‘스몰루프’를 연상시킨다. 아시아가 하나가 된 거대한 만국기를 상징하는 이번 공식포스터는 1996년부터 아시아 영화를 발굴, 소개하여 아시아 영화의 비전을 모색한다는 부산국제영화제의 근본취지와 의미를 고스란히 담아 내고 있으며, 또한 각 나라의 영화들이 상영되는 영화의전당 공간에 대한 상징성도 포스터에 그대로 보여주고 있다.\n \n특히, 올해는 그동안 해운대 바닷가에서 행해졌던 영화제의 행사들을 영화의전당에 집중시킬 계획이라 영화제의 의의와 영화의전당에 대한 상징성도 배가될 예정이다.",
  },
  {
    id: 5,
    title: "제 23회, 2018",
    des: "제23회 부산국제영화제는 전쟁으로 잃은 가족을 향한 그리움과 재회의 염원을 그리는 작품 ‘가족 이야기’와 ‘부산’의 영문자를 대담하게 조합한 포스터를 발표했다. 4가지 이미지가 하나로 모였을 때 완성되어 의미가 극대화되는 올해의 포스터는 그 동안 다난한 굴곡을 겪었던 부산국제영화제가, 흩어졌던 가족들이 한 자리에 모이는 축제처럼 다시금 국내외 영화인과 관객을 아우르는 재회의 장이 되고자 하는 소망을 담고 있다.\n \n현 조선대학교 미술대학 명예교수 1941년 출생, 조선대학교 회화 학사 및 석사 출신이다. 1991년 프랑스 앙제에서 개최한 개인전을 계기로 전 세계에 독특한 한국적 추상회화를 알리기 시작했다. 현재까지도 활발한 작품활동으로 런던, 파리, 뮌헨, 뉴욕, 상하이, 서울, 광주 등 국내외를 넘나들며 전시를 이어 가고 있다. 뉴욕, 쾰른, 시카고, 바젤 등 유수의 아트페어를 비롯해 다양한 초대전 및 단체전에 참가했다. 한국적인 정서를 녹여낸 추상화가의 대가로서, 다채로운 색과 간결한 선, 반복적이나 얽매이지 않는 구성으로 가족에의 깊은 향수를 담아내는 작품들을 통해 국제적인 명성을 얻었다.",
  },
  {
    id: 6,
    title: "제 22회, 2017",
    des: "단순함의 절정에 이른 정상화 화백의 작품은 무엇보다도 형식미를 절제하고 본질에 다가서고자 하는 철학적인 통찰력이 작품을 관통하고 있다. 작품 속 푸른 빛의 단조로운 패턴들은 단순하고 똑같아 보일 수 있지만, 자세히 들여다보면 결코 같지 않은 다른 색채와 형태의 파편들이 모여있음을 발견할 수 있다. 그 결과 전체적으로 볼 때 하나로서의 일체감과 깊이가 느껴진다. 마치 부산의 아름다운 바다와 힘차고 젊은 기운들이 뒤엉킨 듯한 푸른 빛의 단색화는 보기만 해도 깊은 웅장함과 광활한 에너지가 흐르는 듯한 느낌을 전하고 있다. 또한 흰색에서 점점 짙어지는 푸른빛을 가득 머금은 이번 포스터는 22년의 시간 동안 깊이를 더해가며 아시아를 대표하는 영화제로 성장한 부산국제영화제의 넓고 깊은, 선 굵은 세계관과도 닮아있다.\n \n거친 파도를 헤치며 지난 시간 동안 꿋꿋하게 성장해 온 부산국제영화제의 세계관을 담은 올해의 포스터는 이번 영화제를 더욱 빛나게 할 것으로 보인다.",
  },
  {
    id: 7,
    title: "제 21회, 2016",
    des: "제21회 부산국제영화제 공식 포스터는 산속 바위 틈 사이에서 뿌리를 깊게 내린, 홀로 선 소나무를 기본 콘셉트로 내세웠다. ‘소나무의 뿌리가 구천(九泉)에까지 뻗는다’는 옛말이 있듯, 소나무는 땅속 깊숙이 뿌리를 내리기 때문에 가뭄, 폭염, 폭설, 한파에도 흔들림이 없다. 포스터 속 한 그루의 소나무는 부산국제영화제가 탄생한지 아직 20년 밖에 되지 않았지만, 시간이 지날수록 땅속 깊숙이 뿌리를 내리며 더욱 강인해지겠다는 의미를 담고 있다. 변치 않은 한 그루의 소나무처럼 앞으로도 계속 영화제를 지켜 내겠다는 의지를 담은 올해의 포스터는 이번 21회를 더욱 빛나게 할 것으로 보인다.\n \n[ 포스터 디자인: 프로파간다 PROPAGANDA ]\n \n3명의 그래픽 디자이너로 이루어진 프로파간다는 영화, 방송, 공연 등 엔터테인먼트 분야를 전문으로 하는 디자인 스튜디오이다. 특히 영화에 대한 무한한 애정으로 국내외 상업영화, 독립영화 포스터를 아우르며 작업하는 넓은 스펙트럼을 가지고 있기도 하다. 주요 작품으로는 <부산행> <4등> <족구왕> <해무> <피에타> <신세계> <워낭소리> <비몽> 등이 있다.",
  },
  {
    id: 8,
    title: "제 20회, 2015",
    des: "20회 부산국제영화제 공식 포스터는 영화의전당을 주제로 하여 실사 사진을 바탕으로 만든 작품이다.\n \n지난 2011년 개관한 영화의전당은 쿱 힘멜브라우(Coop Himmelblau)가 설계하였으며, 부산국제영화제의 성장과도 같은 상징적인 공간이다. 건축학적으로는 유기적으로 감싸 흐르는 곡면들과 무채색의 장중하고 깊이 있는 색감의 어울림으로 곡면들과 기하학적인 형상들의 불규칙한 만남을 보여주고 있다. 부산국제영화제는 20회를 맞는 특별한 해인 만큼 영화 문화 공간으로 성장한 영화의전당과 함께 새로운 도약을 준비하는 의지를 이번 포스터에 담았다. 과거 부산국제영화제는 전통적으로 회화 작품을 바탕으로 하는 포스터를 주로 만들어 왔으나, 올해는 사진을 활용한 새로운 시도를 하였다. 포스터의 사진과 디자인은 최순대 부산국제영화제 미술감독이 맡아 완성하였다.",
  },
  {
    id: 9,
    title: "제 19회, 2014",
    des: "제 19회 부산국제영화제 공식 포스터는 이혁진 작가의 ‘Emotion¼ Y.R.G.W’을 원화로 하여, 부산국제영화제 최순대 미술감독이 디자인하여 완성됐다. \n\n이혁진 작가의 ‘Emotion¼ Y.R.G.W’는 레진(Resin) 표면에 섬유질을 덧대어 만든 판을 길게 여러 조각으로 잘라서 그림과 결합한 ‘그림조각’ 작품이다. 이는 전통 광주리를 엮는 방법처럼 조각을 가로, 세로로 엮은 다음, 그 조각 위에 그림을 그린 작품으로서 가로와 세로로 얽힌 조각들이 영화와 관객, 영화인이 다 함께 만나는 ‘어울림’의 의미와도 잘 부합되고 있다. 특히, 화려한 색감은 영화제의 축제적 컨셉을 잘 반영하고 있다.\n\n제 19회 공식포스터를 통해 부산국제영화제와 인연을 맺게 된 이혁진 작가는 ‘그림조각’이라는 독창적인 개념을 도입하여, 화려하고 강렬한 이미지들을 통해 형식화된 미술의 틀에서 벗어나는 작업을 계속 해 오고 있다. 부산국제영화제 조직위원회는 19회 포스터 선정을 시작으로 작품 및 해외 게스트 초청, 부대행사 기획 등 본격적으로 영화제 준비에 들어간다. 오는 10월 2일 개막을 시작으로 부산국제영화제는 10일간 개최된다.",
  },
  {
    id: 10,
    title: "제 18회, 2013",
    des: "누아주(nouage): 엮음 페인팅으로 전세계를 사로잡은 신성희 작가, 부산국제영화제와 만나다! 이번 공식 포스터는 신성희 작가의 ‘평면의 진동’(2008년 작)을 원화로 하여, 최순대 부산국제영화제 미술감독이 디자인한 작품이다. ‘평면의 진동’은 신성희 작가의 독창적 고유 화법인 누아주(nouage) 기법을 통해 완성된 작품이다. 영화가 각종의 예술장르가 결합된 종합예술이듯이 ‘평면의 진동‘은 점과 선, 입체가 결합된 자유로운 공간을 표현하고 있다. 또한, 관객과 영화인이 씨줄과 날줄처럼 만나는 영화제의 축제적 성격에도 잘 어울린다.\n\n특히, 제18회 부산국제영화제 공식 포스터는 역대 영화제 중 가장 화사하고 밝은 분위기의 포스터로, 올해 부산국제영화제가 지향하는 ‘흥이 넘치는 축제’로서의 콘셉트를 잘 반영하고 있다.",
  },
  {
    id: 11,
    title: "제 17회, 2012",
    des: "10월 4일(목)부터 10일 13일(토)까지 개최될 제 17회 부산국제영화제가 공식 포스터를 확정, 공개했다. 이번 공식 포스터는 홍푸르메 작가의 ‘빛이 열려[Opening His Light]’를 원화로 하여, 최순대 부산국제영화제 미술감독이 디자인한 작품이다. 홍푸르메 작가의 ‘빛이 열려’ 작품은 태초의 세상을 비추던 빛, 즉 신의 선한 의지가 담긴 ‘창조’와 ‘자유’를 주제로 하였다. 포스터 속에 드러난 ‘빛’은 마치 카메라와 영사기를 통해 살아나는 빛의 세계를 표현하였다. \n특히 수묵과 여백의 강렬한 대비는 ‘영화의 전당’을 통해 새로운 도약을 추구하고자 하는 영화제의 열정과 에너지를 한국적 시각과 감성으로 담아냈다. 제 17회 공식포스터를 통해 부산과 인연을 맺게 된 홍푸르메 작가는 부산 고신대학교 조형미술학과 교수이다. 또한 현재까지도 스위스 ‘미메시스갤러리’와 모스크바 ‘오드리갤러리’ 전속작가로 세계적으로 활동영역을 넓히는 한국을 대표하는 한국화 작가로 알려져 있다.\n공식 포스터 공개와 함께 17회 부산국제영화제는 영화의 전당이 있는 센텀시티와 해운대 그리고 남포동 일대에서 오는 10월 4일부터 10일간 개최될 예정이다.",
  },
  {
    id: 12,
    title: "제 16회, 2012",
    des: "제16회 부산국제영화제의 공식 포스터는 아날로그적 감수성을 담은 세계적 거장 압바스 키아로스타미 감독의 사진 '담 [The Wall]' 을 원화로, 최순대 부산국제영화제 미술감독이 디자인 한 작품이다.\n\n가을날, 담벼락 너머 노랗게 물들어 가는 나뭇잎의 화사함과 담벼락에 비친 나뭇잎 그림자가 주는 은은한 분위기는 축제의 화려함, 그리고 여유로움과 잘 어울리고 있다. 현대를 대표하는 거장감독으로 손꼽히는 압바스 키아로스타미 감독은 사진작가로도 널리 알려져 있으며, 여러 차례 사진전을 가지기도 했다. 부산국제영화제를 세 번이나 방문하기도 한 압바스 키아로스타미 감독은 부산국제영화제에 대한 애정의 표현으로 자신의 사진을 기꺼이 공식포스터의 원화로 제공하였다.",
  },
];

export { movies, DB };
